import { useTranslation } from "react-i18next";
import { Badge } from "ui";

interface PartnershipTypeBadgeProps {
  type: "ONLINE" | "IN_PERSON" | "HYBRID";
}

export function PartnershipTypeBadge(props: PartnershipTypeBadgeProps) {
  const { t } = useTranslation();

  return <Badge variant="outline">{t(`partnershipType.${props.type}`)}</Badge>;
}
